import { Component, HostBinding, Input, OnChanges } from '@angular/core';

import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';

import { BetslipUpsellConstants } from '../../../../lib/betslip-base/models/betslip-upsell.model';
import { UpsellEvent } from '../models';
import { UpsellVisibilityService } from '../services/upsell-visibility.service';

@Component({
    selector: 'bs-upsell-item',
    templateUrl: './upsell-item.component.html',
    standalone: false,
})
export class UpsellItemComponent implements OnChanges {
    @HostBinding('class') className = 'upsell-item';

    @Input() upsellEvent: UpsellEvent;
    @Input() upsellIndex: number;

    trackingSource = BetslipUpsellConstants.TrackingSource;
    showParticipantImage: boolean;
    sourceOfPick = SourceOfPick.Upsell;

    constructor(private upsellVisibilityService: UpsellVisibilityService) {}

    ngOnChanges(): void {
        this.showParticipantImage =
            this.upsellEvent.showParticipantImage && this.upsellVisibilityService.isParticipantImageAvailable(this.upsellEvent.event);
    }

    logoLoaded(logoLoaded: boolean): void {
        this.showParticipantImage = logoLoaded;
    }
}
